import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { ClassificacaoAction } from "./Classificacao.action"
import { ClassificacaoActionTypes, ClassificacaoState } from "./Classificacao.types"


const estadoInicial: ClassificacaoState = {
  currentRequestId: undefined,

  estado: EstadoRequisicao.OCIOSO,
  erros: undefined,

  elementos: [],
}


export const classificacaoReducer: Reducer<ClassificacaoState, ClassificacaoActionTypes> = (state = estadoInicial, action): ClassificacaoState => {
  if (ClassificacaoAction.iniciar.pending.match(action)) {
    if (state.estado !== EstadoRequisicao.OCIOSO) {
      return state;
    }

    return {
      ...state,
      currentRequestId: action.meta.requestId,

      estado: EstadoRequisicao.CARREGANDO,
      erros: undefined,
    }

  } else if (ClassificacaoAction.iniciar.fulfilled.match(action)) {
    if (action.payload === undefined
      || state.estado !== EstadoRequisicao.CARREGANDO
      || state.currentRequestId !== action.meta.requestId) {
       return state;
     }

    return {
      ...state,
      currentRequestId: undefined,

      estado: EstadoRequisicao.BEM_SUCEDIDO,
      elementos: action.payload
    }

  } else if (ClassificacaoAction.iniciar.rejected.match(action)) {
    if (state.estado !== EstadoRequisicao.BEM_SUCEDIDO
      || state.currentRequestId !== action.meta.requestId) {
       return state;
     }

    return {
      ...state,
      currentRequestId: undefined,

      estado: EstadoRequisicao.FALHOU,
      erros: action.payload as ResponseError,
    }
  }

  return state;
}
